/**
 * @generated SignedSource<<20a56f16641166dd5c717595960037e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMaintenanceTicketTagsRelayByIdQuery$variables = {
  id: string;
};
export type useMaintenanceTicketTagsRelayByIdQuery$data = {
  readonly getMaintenanceTicketTag: {
    readonly archivedOn: any | null | undefined;
    readonly createdOn: any;
    readonly id: string;
    readonly name: string;
    readonly organizationId: string | null | undefined;
    readonly partnerId: string | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
  } | null | undefined;
};
export type useMaintenanceTicketTagsRelayByIdQuery = {
  response: useMaintenanceTicketTagsRelayByIdQuery$data;
  variables: useMaintenanceTicketTagsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MaintenanceTicketTag",
    "kind": "LinkedField",
    "name": "getMaintenanceTicketTag",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMaintenanceTicketTagsRelayByIdQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMaintenanceTicketTagsRelayByIdQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f37231c3de06608dad510826c3bc1c9c",
    "id": null,
    "metadata": {},
    "name": "useMaintenanceTicketTagsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useMaintenanceTicketTagsRelayByIdQuery(\n  $id: ID!\n) {\n  getMaintenanceTicketTag(id: $id) {\n    id\n    name\n    createdOn\n    archivedOn\n    organizationId\n    partnerId\n    systemId\n    system {\n      id\n      oldId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "33db6d92988637e9d8022c065066a65a";

export default node;
